/* REDCAMP search: preserve the Impulse open/close and predictive-search listeners.
   After Cancel, remove only a leftover transition class from a CLOSED header panel. */
(function () {
  if (window.__redcampSearchCloseReconcileBound) return;
  window.__redcampSearchCloseReconcileBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var close = target.closest('.rd-header #SearchClose');
    if (!close) return;

    var header = close.closest('.rd-header');
    var panel = header && header.querySelector('.site-header__search-container');
    if (!panel) return;

    // The native listener on the button has already processed this event.
    // Leave the native close, focus, page-scroll, and AJAX event flow intact.
    if (!panel.classList.contains('is-active') &&
        !document.documentElement.classList.contains('js-drawer-open--search')) {
      panel.classList.remove('is-transitioning');
    }
  });
})();
